<section>
  <ion-row class="header-row ion-align-items-center">
    <ion-col>
      <h3 class="popup-heading ml-15">Request Skip Day</h3>
    </ion-col>
    <ion-col size="auto">
      <button mat-icon-button mat-dialog-close class="close-btn">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </ion-col>
  </ion-row>

  <mat-dialog-content class="popup-content">
    <form [formGroup]="skipDayForm" (ngSubmit)="submit()" class="skip-day-form">
      <!-- Date -->
      <div class="form-group">
        <label class="form-label">Date</label>
        <mat-form-field appearance="outline" class="form-field">
          <input matInput [disabled]="true" formControlName="date" readonly />
        </mat-form-field>
      </div>

      <!-- Reason -->
      <div class="form-group">
        <label class="form-label">Reason</label>
        <mat-form-field appearance="outline" class="form-field">
          <textarea matInput rows="2" placeholder="Enter the reason for the skip day." formControlName="reason"></textarea>
          <mat-error *ngIf="skipDayForm.get('reason')?.hasError('required') && skipDayForm.get('reason')?.touched">Enter the reason for skipping day.</mat-error>
        </mat-form-field>
      </div>

      <!-- Submit -->
      <button type="button" class="add_btn fs-14 fs_12ForMobile mr-10" [style.background-color]="buttonColorName" (click)="submitForApproval()" [disabled]="skipDayForm.invalid">Submit for Approval</button>
    </form>
  </mat-dialog-content>
</section>
